const themes = new Set(["newsroom", "nature", "science", "arts", "space", "sports", "weather", "workshop"]);

// Keep the CSS backdrop visible while an image loads or if it fails. Legacy
// or malformed explicit themes must not select a nonexistent CSS class.
export function backdropTheme(episode: { backgroundTheme?: string; backgroundUrl?: string }): string {
  const explicit = typeof episode.backgroundTheme === "string" ? episode.backgroundTheme.trim().toLowerCase() : undefined;
  if (explicit && themes.has(explicit)) return explicit;
  const reference = typeof episode.backgroundUrl === "string" && episode.backgroundUrl.startsWith("theme:")
    ? episode.backgroundUrl.slice(6) : undefined;
  return reference && themes.has(reference) ? reference : "newsroom";
}
